import * as React from 'react';

function SmartLockIcon({ color = '#545454', ...props }) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={18} height={18} viewBox='0 0 16 22' fill='none' {...props}>
			<path
				d='M4.986 11h9.066M4.966 6.297l.01-1.163M3 1h3.712a2 2 0 012 2v16a2 2 0 01-2 2H3a2 2 0 01-2-2V3a2 2 0 012-2z'
				stroke={color}
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default SmartLockIcon;
